import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import CallDashboard from "./CallDashboard";
import SMSDashboard from "./SMSDashboard";
import Dashboard from "./Dashboard";
import ThankYou from "./ThankYou";
import Cancelled from "./Cancelled";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CallDashboard />} />
        <Route path="/sms" element={<SMSDashboard />} />
        <Route path="/billing" element={<Dashboard />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/cancelled" element={<Cancelled />} />
      </Routes>
    </Router>
  );
}
